import Axios from "../config"

const AIChatAPI = {
    // // ?action=get_ai_chat&t=xxx&s=prompt_add&i=&v=Save this as a prompt&u=Prompt 1
    addNewPrompt: async ({userToken, promptName, promptText}) => {
        let response = await Axios
            .request({
                method: "GET",
                params: {
                    action: "get_ai_chat",
                    t: userToken,
                    s: "prompt_add",
                    i: "",
                    u: promptName,
                    v: promptText
                }
            })

        return response.data
    },
    updatePrompt: async ({userToken, promptId, promptMood, promptName}) => {
        let response = await Axios
            .request({
                method: "GET",
                params: {
                    action: "get_ai_chat",
                    t: userToken,
                    s: "prompt_change",
                    i: promptId,
                    v: promptMood,
                    u: promptName
                }
            })

        return response.data
    }
}

export default AIChatAPI
